import * as _ from 'lodash'
import axios from 'axios'

const instance = axios.create({
  baseURL: window.location.origin
})

instance.interceptors.response.use(response => response, error => {
  const status = _.get(error, 'response.status', 0)
  let message = _.get(error, 'response.data.message', error.message)
  switch (status) {
    case 401:
      window.location.reload()
      break
    case 504:
      message = '网络异常'
      break
  }
  throw new Error(message)
})

export default instance

export const toFormData = (data: { [key: string]: any }) =>
  _.chain(data).toPairs().map(pair => `${pair[0]}=${pair[1]}`).join('&').value()
